<div class="flyout-device-info-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'device-info'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/devices.svg" width="32px" height="32px" />
        <span>{{ "flyout.device.title" | translate }}</span>
      </mat-expansion-panel-header>

      @if (webBrowsers && webBrowsers.length > 0) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.device.webBrowser" | translate }}</span>
          </div>
          <div class="value">
            @for (browser of webBrowsers; track browser; let i = $index) {
              <div class="web-browser-item">
                @if (browser.browserType === "chrome") {
                  <img class="browser-icon" src="/assets/img/devices/chrome.svg" />
                }
                @if (browser.browserType === "explorer") {
                  <img class="browser-icon" src="/assets/img/devices/internet-explorer.svg" />
                }
                @if (browser.browserType === "edge") {
                  <img class="browser-icon" src="/assets/img/devices/edge.svg" />
                }
                @if (browser.browserType === "safari") {
                  <img class="browser-icon" src="/assets/img/devices/safari.svg" />
                }
                @if (browser.browserType === "firefox") {
                  <img class="browser-icon" src="/assets/img/devices/firefox.svg" />
                }
                @if (browser.browserType === "opera") {
                  <img class="browser-icon" src="/assets/img/devices/opera.svg" />
                }
                @if (browser.browserType === "blackberry") {
                  <img class="browser-icon" src="/assets/img/devices/blackberry.svg" />
                }
                <span>{{ browser.name }}</span>
                @if (i < webBrowsers.length - 1) {
                  <span>,</span>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (nativeApps && nativeApps.length > 0) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.device.nativeApp" | translate }}</span>
          </div>
          <div class="value">
            @for (app of nativeApps; track app.platform; let i = $index) {
              <div class="web-browser-item">
                <span>{{ app.platform }}</span>
                @if (i < nativeApps.length - 1) {
                  <span>,</span>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (screenResolutions && screenResolutions.length > 0) {
        <div class="expansion-panel-row values">
          <div class="label">{{ "flyout.device.resolution" | translate }}</div>
          <div class="value">
            @for (screenResolution of screenResolutions; track screenResolution; let i = $index) {
              <div class="web-browser-item">
                <span>{{ screenResolution }}</span>
                @if (i < screenResolutions.length - 1) {
                  <span>,</span>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (operatingSystems && operatingSystems.length > 0) {
        <div class="expansion-panel-row values">
          <div class="label">{{ "flyout.device.os" | translate }}</div>
          <div class="value">
            @for (operatingSystem of operatingSystems; track operatingSystem; let i = $index) {
              <div class="web-browser-item">
                @if (operatingSystem.osType === "windows") {
                  <img class="browser-icon" src="/assets/img/devices/windows.svg" />
                }
                @if (operatingSystem.osType === "apple") {
                  <img class="browser-icon" src="/assets/img/devices/apple.svg" />
                }
                @if (operatingSystem.osType === "linux") {
                  <img class="browser-icon" src="/assets/img/devices/linux.svg" />
                }
                @if (operatingSystem.osType === "android") {
                  <img class="browser-icon" src="/assets/img/devices/android.svg" />
                }
                @if (operatingSystem.osType === "blackberry") {
                  <img class="browser-icon" src="/assets/img/devices/blackberry.svg" />
                }
                <span>{{ operatingSystem.name }}</span>
                @if (i < operatingSystems.length - 1) {
                  <span>,</span>
                }
              </div>
            }
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
